import { useMutation } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

interface GetCertificateLinkPayload {
  vesselId: string
  filename: string
  versionId?: string
}

interface GetCertificateLinkResponse {
  signedUrl: string
}

export function useGetCertificateLink() {
  const fetchRequest = useFetch()

  return useMutation<
    GetCertificateLinkResponse,
    Error,
    GetCertificateLinkPayload
  >({
    mutationFn: ({ vesselId, filename, versionId }) =>
      fetchRequest(
        `${apiBase()}/vessels/${vesselId}/file?name=${encodeURIComponent(filename)}${
          versionId ? `&versionId=${encodeURIComponent(versionId)}` : ''
        }`,
      ) as Promise<GetCertificateLinkResponse>,
  })
}
